import { render, staticRenderFns } from "./juyi-pro-audit.vue?vue&type=template&id=25e67197&scoped=true"
import script from "./juyi-pro-audit.vue?vue&type=script&lang=js"
export * from "./juyi-pro-audit.vue?vue&type=script&lang=js"
import style0 from "./juyi-pro-audit.vue?vue&type=style&index=0&id=25e67197&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e67197",
  null
  
)

export default component.exports